/**
 * Calculates the timestamp for the next session refresh.
 * Strategy: Refresh halfway between now to expiry.
 * 
 * @param {string} expiryIsoString - The absolute expiry time from the server (ISO 8601).
 * @param {number} [nowMs=Date.now()] - The current time in milliseconds
 * @returns {?number} The timestamp (ms) to schedule the refresh, or null if already expired/invalid.
 */
export function refreshAtFromExpiry(expiryIsoString: string, nowMs: number = Date.now()): number | null {
  const expiryMs = new Date(expiryIsoString).getTime()
  if (!Number.isFinite(expiryMs)) return null

  const remainingMs = expiryMs - nowMs
  if (remainingMs <= 0) return null

  // Halfway between now and expiry
  return nowMs + Math.floor(remainingMs / 2)
}
